import { useState } from "react";
import DOMPurify from "dompurify";

const FormularDoprava = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telefon, setTelefon] = useState('');
    const [info, setInfo] = useState('');
    const [produkt, setProdukt] = useState('');
    const [canOrder, setCanOrder] = useState(false);
    const [errors, setErrors] = useState({});

    const options = [
        "Iveco daily do 3,5t",
        "Iveco daily nad 3,5t",
        "Mercedes axor nad 7,5t",
        "Mercedes atego nad 3,5t",
        "Mercedes axor hydraulická ruka",
        "Bager YANMAR zemné práce",
        "Bager YANMAR búracie kladivo",
        "UNC 753",
        "Valec Bomag BW 80 s obsluhou",
    ];

    const canOrderForm = (e) => {
        setCanOrder(e.target.checked); // Fixed: was always setting false
    };

    // --- Input filters ---
    const handleNameChange = (e) => {
        const val = e.target.value.replace(/[^a-zA-ZÀ-žáäčďéíľĺňóôŕšťúýžÁÄČĎÉÍĽĹŇÓÔŔŠŤÚÝŽ\s\-]/g, '');
        setName(val);
        if (errors.name) setErrors((prev) => ({ ...prev, name: '' }));
    };

    const handleTelefonChange = (e) => {
        const val = e.target.value.replace(/[^\d+\s\-]/g, '').slice(0, 13);
        setTelefon(val);
        if (errors.telefon) setErrors((prev) => ({ ...prev, telefon: '' }));
    };

    // --- Validation ---
    const validateName = (v) => {
        if (!v.trim()) return 'Meno je povinné';
        if (v.trim().length < 2) return 'Meno musí mať aspoň 2 znaky';
        return '';
    };
    const validateEmail = (v) => {
        if (!v.trim()) return 'Email je povinný';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'Zadajte platnú emailovú adresu';
        return '';
    };
    const validateTelefon = (v) => {
        if (!v.trim()) return 'Telefón je povinný';
        if (!/^[\d+][\d\s\-]{8,12}$/.test(v)) return 'Zadajte platné telefónne číslo (10 číslic)';
        return '';
    };
    const validateProdukt = (v) => (!v ? 'Vyberte vozidlo alebo stroj' : '');

    const handleBlur = (field, value) => {
        const validators = { name: validateName, email: validateEmail, telefon: validateTelefon, produkt: validateProdukt };
        const error = validators[field] ? validators[field](value) : '';
        setErrors((prev) => ({ ...prev, [field]: error }));
    };

    const inputClass = (field) =>
        `w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 transition-colors ${
            errors[field]
                ? 'border-red-400 focus:ring-red-300'
                : 'border-gray-300 focus:ring-red-400'
        }`;

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = {
            name: validateName(name),
            email: validateEmail(email),
            telefon: validateTelefon(telefon),
            produkt: validateProdukt(produkt),
        };

        if (Object.values(validationErrors).some((err) => err !== '')) {
            setErrors(validationErrors);
            return;
        }

        const sanitizedData = {
            name: DOMPurify.sanitize(name),
            email: DOMPurify.sanitize(email),
            telefon: DOMPurify.sanitize(telefon),
            info: DOMPurify.sanitize(info),
            produkt: DOMPurify.sanitize(produkt),
        };

        const formData = new URLSearchParams();
        Object.entries(sanitizedData).forEach(([k, v]) => formData.append(k, v));

        try {
            const response = await fetch('https://petromin.sk/phpmailer/orderHandler.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formData.toString(),
            });
            const data = await response.json();
            if (data.status === 'success') {
                alert(data.message);
            } else {
                alert('Nastala chyba: ' + data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Nastala chyba pri odosielaní formulára.');
        }
    };

    return (
        <div className="max-w-full mb-10">
            <form className="max-w-6xl mx-auto bg-white p-8 border border-gray-300 rounded-lg shadow-md" onSubmit={handleSubmit}>
                {/* Meno */}
                <div className="mb-6">
                    <label htmlFor="name" className="block text-gray-700 font-bold mb-2">Meno a Priezvisko:</label>
                    <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={handleNameChange}
                        onBlur={() => handleBlur('name', name)}
                        className={inputClass('name')}
                        placeholder="Ján Novák"
                    />
                    {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                </div>

                <div className="flex w-full gap-4">
                    {/* Email */}
                    <div className="mb-6 w-full">
                        <label htmlFor="email" className="block text-gray-700 font-bold mb-2">Email:</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={e => { setEmail(e.target.value); if (errors.email) setErrors(p => ({ ...p, email: '' })); }}
                            onBlur={() => handleBlur('email', email)}
                            className={inputClass('email')}
                            placeholder="jan@example.sk"
                        />
                        {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                    </div>

                    {/* Telefón */}
                    <div className="mb-6 w-full">
                        <label htmlFor="telefon" className="block text-gray-700 font-bold mb-2">Telefón:</label>
                        <input
                            type="tel"
                            id="telefon"
                            value={telefon}
                            onChange={handleTelefonChange}
                            onBlur={() => handleBlur('telefon', telefon)}
                            className={inputClass('telefon')}
                            placeholder="0918 495 001"
                        />
                        {errors.telefon && <p className="text-red-500 text-xs mt-1">{errors.telefon}</p>}
                    </div>
                </div>

                {/* Produkt */}
                <div className="mb-6">
                    <label htmlFor="produkt" className="block text-gray-700 font-bold mb-2">Výber vozidla / stroja:</label>
                    <select
                        id="produkt"
                        value={produkt}
                        onChange={e => { setProdukt(e.target.value); if (errors.produkt) setErrors(p => ({ ...p, produkt: '' })); }}
                        onBlur={() => handleBlur('produkt', produkt)}
                        className={inputClass('produkt')}
                    >
                        <option value="" disabled>Vyberte možnosť</option>
                        {options.map((option, index) => (
                            <option key={index} value={option}>{option}</option>
                        ))}
                    </select>
                    {errors.produkt && <p className="text-red-500 text-xs mt-1">{errors.produkt}</p>}
                </div>

                {/* Dodatočné info */}
                <div className="mb-6">
                    <label htmlFor="info" className="block text-gray-700 font-bold mb-2">Dodatočné info:</label>
                    <input
                        type="text"
                        id="info"
                        value={info}
                        onChange={e => setInfo(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-400"
                        placeholder="Nepovinné"
                    />
                </div>

                {/* GDPR */}
                <div className="mb-6 flex items-start gap-2">
                    <input type="checkbox" className="mt-1 accent-red-600" onChange={canOrderForm} />
                    <span className="text-sm text-gray-600">
                        Oboznámil(a) som sa s podmienkami ochrany osobných údajov a súhlasím so spracovaním údajov uvedených vo formulári.
                    </span>
                </div>

                <button
                    type="submit"
                    className={`w-full py-3 px-4 rounded-md text-white font-semibold transition duration-200 ${
                        canOrder ? 'bg-red-600 hover:bg-red-700 cursor-pointer' : 'bg-gray-400 cursor-not-allowed opacity-50'
                    }`}
                    disabled={!canOrder}
                >
                    Odošli
                </button>
            </form>
        </div>
    );
};

export default FormularDoprava;
